import React, { useEffect, useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton";

const WaitingDisplay2 = ({
  title = "Créez votre premier dossier",
  subtitle = "Les dossiers sont le centre de votre activité sur hexagone !",
  goAction = () => {},
  actionText = "Nouveau Dossier",
}) => {
  return (
    <div className="  flex flex-row justify-start items-start">
      <div className="relative justify-center items-center flex  w-fit  mt-10  p-0 bg-white  border-1 rounded-xl">
        {/* Your content */}
        <div className="relative bg-gradient-to-r h-fit from-wshadow_75 p-4 to-transparent rounded-xl z-10 flex flex-row items-start gap-10  ">
          <div className="relative  rounded-xl z-10 mr-48 flex flex-col gap-2  flex-grow ">
            <div className="text-h2 font-bold text-gray-800">{title}</div>{" "}
            <div className="text-h3 text-shadow_50">{subtitle}</div>
          </div>
          <div>
            <img
              src="https://i.ibb.co/TxSFfkjT/Add-Favrois.png"
              className="w-44 h-auto rounded-lg  "
            ></img>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitingDisplay2;
